// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"cc0c7af1","392":"599e0322"}[chunkId] + ".css";
};